import { render, staticRenderFns } from "./custom-footer.vue?vue&type=template&id=f0673e40"
import script from "./custom-footer.vue?vue&type=script&lang=js"
export * from "./custom-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports